export default {
  index: [
    {
      path: '/contractInfo',
      component: resolve => require(['./contractInfoIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/contractInfo/_router.js